import { render } from "./TimerCard.vue?vue&type=template&id=53a4720a&scoped=true"
import script from "./TimerCard.vue?vue&type=script&lang=js"
export * from "./TimerCard.vue?vue&type=script&lang=js"

import "./TimerCard.vue?vue&type=style&index=0&id=53a4720a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a4720a"]])

export default __exports__